import lsh from '@/assets/modules/localStorageHelper'
import gql from 'graphql-tag'
import base from '@/mixins/pagination/base'

export default {
  data () {
    return {
      translations: {},
      userLang: null
    }
  },

  methods: {
    refetch () {
      this.$apollo.queries.translations.refetch()
    },

    /**
     * Inserts a language object in the current object
     * @param {*} rtr The current object to be populated
     * @param {*} lang The language we would like to insert
     */
    addLanguage (rtr, lang) {
      rtr[lang] = {}
    },

    /**
     * Inserts a key object in the current object
     * @param {*} rtr The current object to be populated
     * @param {*} key The key we would like to insert
     */
    addKey (rtr, key) {
      rtr[key] = {}
    },

    initiali18 () {
      try {
        let { long: lang } = lsh.getLocale()
        this.$locale.change(lang)

        let languages = lsh.getData('translations')
        this.refreshi18(languages)
      } catch (e) {
        console.error(e)
      }
    },

    refreshi18 (languages) {
      try {
        let tmp = this.$locale.current()
        
        for (let lang in languages) {
          this.$i18n.setLocaleMessage(lang, languages[lang])
        }
        
        this.$locale.change(null); this.$locale.change(tmp)
      } catch (e) {
        console.error(e)
      }
    },

    storeTranslationObject (rtr) {
      lsh.setBlock('translations', rtr)
      this.refreshi18(rtr)
    },

    updateUserLang () {
      this.userLang = lsh.getLocale().long
    }
  },

  computed: {
    /**
     * Gets translation's data
     */
    getLanguageSet () {
      return this.translations.set || []
    },

    makeTranslationObject () {
      let rtr = {}

      // Each content entry
      for (let content of this.getLanguageSet) {
        if (content.key.indexOf('.') > -1) {
          // Language...
          let language = content.language
          if (!rtr[language]) this.addLanguage(rtr, language)

          // Split key from value...
          let parts = content.key.split('.')
          let key = parts[0]
          if (key[0] === '/') key = key.substring(1)
          let value = parts[1]

          // Add all keys to structure
          key = key.split('/')
          let jsonWalker = rtr[language]
          for (let k of key) {
            if (!jsonWalker[k]) {
              this.addKey(jsonWalker, k)
            }

            jsonWalker = jsonWalker[k]
          }

          // Add value to json walker
          jsonWalker[value] = content.parts.text
        }
      }

      this.storeTranslationObject(rtr)
      return rtr
    }
  },

  created () {
    this.initiali18()

    this.$bus.on('reFetchTranslations', this.updateUserLang)
  },

  mounted () {
    this.updateUserLang()
  },

  beforeDestroy () {
    this.$bus.off('reFetchTranslations', this.updateUserLang)
  },

  mixins: [
    base
  ],

  // Apollo...
  apollo: {
    user: {
      query: gql`query {
        user  {
          id,
          settings {
            language
          }
        }
      }`,
      fetchPolicy: 'cache-and-network',
      result (ApolloQueryResult) {
        // Get language from response and update language...
        if (!ApolloQueryResult.loading) {
          let { data: { user: { settings: { language } = {} } = {} } } = ApolloQueryResult
          lsh.setData('interface', 'language', language)

          // Use language specified on API or local stored or default to sl_SI
          let { long: newLang } = lsh.getLocale()

          this.$locale.change(newLang)

          if (this.userLang !== newLang) {
            this.userLang = newLang
          }

        }
      }
    },

    translations: {
      query: gql`query ($language: [String!]) {
        translations: content (type: [page, snippet], language: $language, limit: -1) {
          set {
            id,
            key,
            language,
            parts {
              ... on ContentPage {text: body}
              ... on ContentSnippet {text}
            }
          }
        }
      }`,

      skip() {
        return !this.userLang
      },

      variables () {
        return {
          language: this.userLang
        }
      },

      fetchPolicy: 'cache-and-network',
      result (ApolloQueryResult) {
        if (!ApolloQueryResult.loading) {
          /**
           * If content language is not the last requested one; ignore this response.
           * Apollo should already reject responses if they are for older requests of this query,
           * but just in case.
           */
          let { data: { translations: { set = [] } } } = ApolloQueryResult
          if (set[0] && set[0].language !== this.userLang) return

          this.storeTranslationObject(this.makeTranslationObject)
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/pagination/providers/translations.js